import { makeModelSelectors } from '@minerva-analytics/pantheon';

import selectedCategorySubcategories from './selectedCategorySubcategories';
import selectedCategoryEMHSubs from './selectedCategoryEMHSubs';
import selectedCategorySpecialSubs from './selectedCategorySpecialSubs';

export default {
  ...makeModelSelectors({ model: `subcategory`, pluralModel: `subcategories` }),
  selectedCategorySubcategories,
  selectedCategorySpecialSubs,
  selectedCategoryEMHSubs,
};
